var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('DynamicToolbar',{attrs:{"title":"Manual Readings","loading":_vm.loading,"color":"blue darken-4","icon":"mdi-map-clock","theme":"dark"}}),_c('manual-readings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }